module.exports = __webpack_public_path__ + "static/media/checkmark.dc8f524c.svg";